export const savedScheduleindexPrefix = 'saved-schedule-'

export interface SavedSchedule {
    id: string
    title: string
    thumbnail: string
    date: string
    schedule: any
}
